export default {
  ALIPAY_WEB: {
    value: 'alipay-web',
    label: '支付宝',
  },

  ALIPAY_GLOBAL_WEB: {
    value: 'alipayGlobal-web',
    label: '支付宝',
  },

  WECHAT_SCAN: {
    value: 'wechat-scan',
    label: '微信',
  },

  ANTOM_CKP: {
    value: 'antom-ckp',
    label: 'Antom收银台',
  },
}
